import 'shared/common'

window.addEventListener('DOMContentLoaded', () => {
  const viewJobsBtn = document.querySelector('.view-available-jobs')
  if (!viewJobsBtn) return
  const target = document.querySelector('.view-available-jobs-target')
  if (!target) return

  viewJobsBtn.addEventListener('click', (e) => {
    e.preventDefault()
    target.scrollIntoView({ behavior: 'smooth' })
  })
})
